<template>
  <div>
    <start-reporting-case-component
      v-if="item.canStartReportingCase && !item.caseId"
      :item="item">
    </start-reporting-case-component>
    <link-component
      v-else-if="item.inProgress"
      :name="'CaseView'"
      :params="{ caseId: item.casePk }">
        <translate> Reporting case created </translate>
    </link-component>
    <span v-else>
      {{ item.reportComment }}
    </span>
  </div>
</template>
<script>
  import LinkComponent from '@/components/layout/utility/LinkComponent'
  import StartReportingCaseComponent from '@/components/layout/utility/StartReportingCaseComponent'

  export default {
    name: 'reports-comment-component',
    components: {
      LinkComponent,
      StartReportingCaseComponent
    },
    props: {
      item: {
        type: Object,
        required: true
      }
    }
  }
</script>
